import { Calendar, Clock, Video } from "lucide-react";
import { Reveal } from "./Reveal";

export default function ClosingCta({ onBook }) {
  return (
    <section data-testid="closing-cta-section" className="bg-cream px-6 md:px-14 py-20 md:py-28">
      <div className="max-w-3xl mx-auto text-center">
        <Reveal>
          <h2 className="font-serif tracking-tight text-2xl md:text-4xl leading-tight text-espresso">
            Vielleicht ist jetzt der Moment.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 text-base md:text-lg font-light leading-relaxed text-taupe">
            Nicht irgendwann. Nicht wenn du endlich alles verstanden hast. Nicht wenn
            es sich von alleine erledigt hat. Sondern jetzt.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Du musst heute noch nicht wissen, wie Loslassen geht.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 font-serif italic text-xl md:text-2xl leading-snug text-espresso tracking-tight">
            Du darfst einfach bereit sein, damit anzufangen.
          </p>
        </Reveal>
        <Reveal delay={0.28}>
          <div data-testid="closing-event-facts" className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs md:text-sm text-taupe">
            <span className="flex items-center gap-2"><Calendar size={15} className="text-gold" /> Donnerstag, 03.09.2026</span>
            <span className="flex items-center gap-2"><Clock size={15} className="text-gold" /> 20:00 – 21:00 Uhr</span>
            <span className="flex items-center gap-2"><Video size={15} className="text-gold" /> Live via Zoom</span>
            <span className="font-medium text-espresso">CHF 21.–</span>
          </div>
        </Reveal>
        <Reveal delay={0.36}>
          <button
            data-testid="closing-booking-button"
            onClick={onBook}
            className="mt-10 rounded-full bg-espresso px-10 py-4 text-sm md:text-base font-medium tracking-wide text-cream transition-transform duration-300 hover:scale-[1.03] active:scale-[0.98]"
          >
            JA, ICH BIN BEREIT LOSZULASSEN
          </button>
        </Reveal>
      </div>
    </section>
  );
}
